// extracted by mini-css-extract-plugin
module.exports = {"row":"SpecificationParametersList_row__KwBPj"};